<script setup lang="ts">
import {
  PAvatar,
  PAvatarSize,
  PAvatarType,
  PCard,
  PCardSize,
  PContextMenu,
  PItem,
  PList,
  PLoader,
  PMaxLines,
  PSpace,
  PSpaceSize,
  PTextTitle2,
  usePrevioDS,
} from '@previo/design-system'
import { ref } from 'vue'
import { $t } from '@previo/core'
import { Color } from '@previo/codebooks'
import { useLogout } from './composables/useLogout'
import { Routes } from '~/router/routes'
import { useUserStore } from '~/store/user'

const ds = usePrevioDS()
const userStore = useUserStore()
const userOptionsMenuVisible = ref<boolean>(false)
const { isDoingLogout, logout } = useLogout()
</script>

<template>
  <p-card
    :pa-mobile="PCardSize.SM"
    class="pms-app-menu-bar p-flex p-no-wrap p-items-center"
    :color="Color.PRIMARY"
  >
    <p-space :mobile="PSpaceSize.ZERO" :laptop="PSpaceSize.XS" />

    <slot name="start">
      <div class="p-flex p-flex-center">
        <router-link :to="{ name: Routes.CALENDAR_INDEX_P1_P2 }">
          <img
            class="p-cursor-pointer"
            src="@previo/design-system/src/public/logo/previo-white.svg"
            height="32"
            width="62"
            alt="Previo logo"
          />
        </router-link>
      </div>
    </slot>

    <div class="p-flex p-flex-1 p-no-wrap p-items-center">
      <slot />
    </div>

    <p-space :mobile="PSpaceSize.MD" />

    <p-avatar
      v-if="ds.screen().isLaptopAndLarge"
      :type="PAvatarType.MONOGRAM"
      :text="userStore.user.name"
      :size="PAvatarSize.SMALL"
      class="p-card-avoid-border"
      enable-hover
      @click="userOptionsMenuVisible = !userOptionsMenuVisible"
    >
      <p-context-menu
        v-model="userOptionsMenuVisible"
        :title="userStore.user.name"
        cy="user-options"
        no-parent-event
      >
        <p-list>
          <template v-if="ds.screen().isLaptopAndLarge">
            <div class="p-display-flex">
              <p-space :mobile="PSpaceSize.SM" />
              <p-text-title2
                :text="userStore.user.name"
                :color="Color.PRIMARY"
                :max-lines="PMaxLines.ONE"
              />
            </div>
            <p-space :mobile="PSpaceSize.SM" vertical />
          </template>

          <slot name="user-options" />

          <p-item :text="$t('Log out')" cy="logout" class="p-flex p-items-center" @click="logout">
            <p-loader v-if="isDoingLogout" :color="Color.PRIMARY" />
          </p-item>
        </p-list>
      </p-context-menu>
    </p-avatar>

    <slot name="end" />

    <p-space :mobile="PSpaceSize.ZERO" :laptop="PSpaceSize.XS" />
  </p-card>
</template>

<style lang="scss" scoped>
@import '@previo/design-system/src/assets/scss/shared/mixins';

.pms-app-menu-bar {
  height: 56px;

  @include laptopAndLarge {
    height: 52px;
  }
}
</style>
